'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STAGE_MESSAGE_ON_STUBBED_THREAD = exports.STAGE_MESSAGE_ON_STUBBED_THREAD = 'STAGE_MESSAGE_ON_STUBBED_THREAD';

var ADD_VISITOR_MESSAGE_TO_STUBBED_THREAD = exports.ADD_VISITOR_MESSAGE_TO_STUBBED_THREAD = 'ADD_VISITOR_MESSAGE_TO_STUBBED_THREAD';

var RESET_STUBBED_THREAD = exports.RESET_STUBBED_THREAD = 'RESET_STUBBED_THREAD';